export var DEFAULT_IMAGE = {
    source: 'https://assets.sunzi.cool/mini-me/test-face.svg',
    isDefault: true,
    image: 'https://assets.sunzi.cool/mini-me/test-face.svg',
    height: 435,
    width: 317,
    userImage: 'https://assets.sunzi.cool/mini-me/test-face.svg',
    faceRecognizeData: {
        landmark: {
            chin: {
                x: 157,
                y: 445
            },
            leftEyebrow: {
                x: 85,
                y: 201
            },
            rightEyebrow: {
                x: 221,
                y: 198
            },
            leftEyePupil: {
                x: 93,
                y: 239
            },
            rightEyePupil: {
                x: 216,
                y: 239
            },
            nose: {
                x: 155,
                y: 316
            },
            mouthLowerLip: {
                x: 156,
                y: 373
            },
            mouthUpperLip: {
                x: 156,
                y: 354
            }
        },
        faceRect: {
            top: 191,
            left: 30,
            width: 261,
            height: 261
        }
    }
};
export var SaveLocalKey = '_sunzi_mini_me_local_image';
export var faceppConfig = {
    baseUrl: 'https://api-us.faceplusplus.com',
    apiKey: 'cdQSZCKTyTh7mTEvv1Pi-gz7q6lSOJJ7',
    apiSecret: 'HoFsxnPuiFYjDvlQNi-vAD-PsHddnHb0'
};
export var fabricConfig = {
    control: {
        mirror: 'https://assets.sunzi.cool/mini-me/icons/flipX1.png',
        scale: 'https://assets.sunzi.cool/mini-me/icons/resize.png',
        edit: 'https://sunzi7n.imaiyuan.com/fabric/icon/edit.png',
        rotate: 'https://assets.sunzi.cool/mini-me/icons/rotate.png',
        layout: 'https://sunzi7n.imaiyuan.com/fabric/icon/layout.png',
        camera: 'https://assets.sunzi.cool/mini-me/icons/edit.png',
        deleteImage: 'https://sunzi7n.imaiyuan.com/fabric/icon/delete-1.png'
    },
    attribute: {
        borderScaleFactor: 2.4,
        cornerSize: 26,
        textPadding: 6
    }
};
